/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { replace } from 'react-router-redux';
import qs from 'qs';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
  Divider,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashErrorMessage } from '../../../actions/flash';
import { fetchM } from '../../../actions/fetchM';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import isNumber from '../../../utils/numbers/isNumber';
import NavBar from '../../../components/NavBar';
import PageNav from '../../../components/PageNav';
import SearchFilter from '../../../components/SearchFilter';
import SortButton from '../../../components/SortButton';
import ProjectUnitActivities from '../../../components/ProjectUnitActivities';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class Activities extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
    }),
    routerParams: PropTypes.shape({
      id: PropTypes.string,
      unitID: PropTypes.string,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data || [];
    const query = decodeSearch(props.location.search);
    const search = query.search || '';
    const activitiesData = [];
    return {
      data,
      query,
      search,
      activitiesData,
    };
  }
  constructor(props) {
    super(props);
    const state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    this.state = state;
  }
  componentDidMount() {
    const { query } = this.props.location;
    this.getProjectUnitActivities(query);
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    const state = Activities.getPropsToState(nextProps);
    if (this.state.activitiesData) {
      state.activitiesData = this.state.activitiesData;
    }
    this.setState({ ...state }, () => {
      if (!this.state.activitiesData) {
        this.getProjectUnitActivities(query);
      }
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async getProjectUnitActivities(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.routerParams.id}/units/${this.props.routerParams.unitID}/activities/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const activitiesData = await res.json();
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        count,
        limit,
        offset,
        activitiesData,
      });
      await this.setLoading(false);
    }
  }
  hasAccess(check = false) {
    if (this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isSuperAdmin) {
      return true;
    }
    return check;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    } else {
      this.setState({ search: '' });
    }
  }
  handleOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  async replaceQuery(query, resetPage = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) queryNew.page = 1;
    await this.getProjectUnitActivities(query);
    store.dispatch(replace(`/projects/${this.props.routerParams.id}/units/${this.props.routerParams.unitID}/activities/?${encodeSearch(queryNew)}`));
    await this.setLoading(false);
  }
  sortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { activitiesData } = this.state;
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('Unit Activity Logs')}
        />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16}>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                placeholder={t('Search')}
                setAdvanceFilter={() => {}}
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.activitiesData.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              />
            </Grid.Column>
            <Grid.Column width={16} textAlign="center">
              <br />
              <Divider horizontal>
                <Link to={`/projects/${this.props.routerParams.id}/units/${this.props.routerParams.unitID}/`}>
                  <small>
                    {this.state.data.reference ? `${this.state.data.reference}, ` : ''}{this.state.data.project ? this.state.data.project.shortName : ''}
                  </small>
                </Link>
              </Divider>
              <Segment>
                <ProjectUnitActivities
                  data={activitiesData || []}
                  hasAccess={this.hasAccess()}
                  loading={this.state.loading}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Activities.mapStateToProps)(Activities));



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Activities.jsx